import {
  Component,
  ElementRef,
  ViewEncapsulation,
  Renderer
} from '@angular/core';

import { BaseDynamicComponent } from './base-dynamic-component';
/**
 * Represents the modal backdrop shaped by CSS.
 */
export class CSSBackdrop extends BaseDynamicComponent {
public cssClass: string;
public styleStr: string;
/**
 * @param {?} el
 * @param {?} renderer
 */
constructor(el: ElementRef, renderer: Renderer) {
    super(el, renderer);
    this.activateAnimationListener();

    const style = {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    };
    Object.keys(style).forEach( k => this.setStyle(k, style[k]) );
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'css-backdrop',
  host: {
    '[attr.class]': 'cssClass',
    '[attr.style]': 'styleStr'
  },
  encapsulation: ViewEncapsulation.None,
  template: ``
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer, },
];
}

function CSSBackdrop_tsickle_Closure_declarations() {
/** @type {?} */
CSSBackdrop.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CSSBackdrop.ctorParameters;
/** @type {?} */
CSSBackdrop.prototype.cssClass;
/** @type {?} */
CSSBackdrop.prototype.styleStr;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
